import { useDisableInspect } from "./utils/disableInspect";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NavigationSetter from "./Navigation/NavigationSetter";
import { AdminRoutes, AuthRoutes, Path, SuperAdminRoutes } from "./routes/routes";

function App() {
  useDisableInspect();

  return (
    <BrowserRouter>
      <NavigationSetter />
      <Routes>
        <Route path="/" element={<Navigate to={Path.Login} replace />} />
        
     
        {AuthRoutes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
        <Route path={SuperAdminRoutes.path} element={SuperAdminRoutes.element}>
          {SuperAdminRoutes.children.map(({ path, element, index }, i) => (
            <Route key={path || `index-${i}`} path={path} element={element} index={index} />
          ))}
        </Route>
        <Route path={AdminRoutes.path} element={AdminRoutes.element}>
          {AdminRoutes.children.map(({ path, element, index }, i) => (
            <Route key={path || `index-${i}`} path={path} element={element} index={index} />
          ))}
        </Route>
        
        <Route path="*" element={<Navigate to={Path.Login} replace />} />
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </BrowserRouter>
  );
}

export default App;
